/**
 * Subset of `team.settings.outboundLabels.wms` the policy inspects. Structural
 * so callers can pass either the backend-db-schema or redo-model Team's
 * settings — both of which include these fields.
 */
export interface LicensePlateScanSettings {
  strictLicensePlateScan?: boolean | null;
  strictLicensePlateScanBypassMerchantIds?:
    | readonly { toString(): string }[]
    | null;
}

/**
 * Returns true if a scanner at this workflow step must receive an inventory item
 * license plate (not an SKU/product barcode).
 *
 * `merchantTeamId` identifies which merchant the scan would be attributed to
 * (e.g. the owner of the product or inventory item). When provided and present
 * in the 3PL's bypass list, strict mode is treated as off for this scan.
 */
export function isLicensePlateScanRequired(args: {
  wms: LicensePlateScanSettings | null | undefined;
  merchantTeamId?: string | null;
}): boolean {
  if (args.wms?.strictLicensePlateScan !== true) {
    return false;
  }
  if (
    args.merchantTeamId &&
    isMerchantBypassed(
      args.wms.strictLicensePlateScanBypassMerchantIds,
      args.merchantTeamId,
    )
  ) {
    return false;
  }
  return true;
}

function isMerchantBypassed(
  bypassList: readonly { toString(): string }[] | null | undefined,
  merchantTeamId: string,
): boolean {
  if (!bypassList || bypassList.length === 0) {
    return false;
  }
  for (const id of bypassList) {
    if (id.toString() === merchantTeamId) {
      return true;
    }
  }
  return false;
}
